import styled from "styled-components"

const StyledDivider = styled.svg``

export { StyledDivider }
